import { render, staticRenderFns } from "./PreferencAnnuaire.vue?vue&type=template&id=51dfa1d8&"
import script from "./PreferencAnnuaire.vue?vue&type=script&lang=js&"
export * from "./PreferencAnnuaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports